<button mat-icon-button tabindex="1" class="close-button" [mat-dialog-close]="false">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title class="delete-title">
  <mat-icon color="warn" class="title-icon">warning</mat-icon>
  {{ data.title }}
</h1>

<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

  <!-- Información de la entidad -->
  <mat-card class="entity-info-card" *ngIf="data.entityName">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>info</mat-icon>
        {{ data.entityName }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="data.entityDetails">
      <div class="entity-details">
        <div *ngFor="let detail of data.entityDetails | keyvalue" class="detail-row">
          <span class="detail-label">{{ detail.key }}:</span>
          <span class="detail-value">{{ detail.value }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Advertencia -->
  <mat-card class="warning-card" *ngIf="data.relatedItems">
    <mat-card-header>
      <mat-card-title class="warning-title">
        <mat-icon color="warn">delete_forever</mat-icon>
        ¡Atención! Esta acción es irreversible
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="warning-message">{{ data.warningMessage }}</p>

      <div class="related-items" *ngIf="data.relatedItems && data.relatedItems.length > 0">
        <p class="related-items-title">Se eliminarán los siguientes elementos relacionados:</p>
        <ul class="items-list">
          <li *ngFor="let item of data.relatedItems" class="item">
            <mat-icon class="item-icon" color="warn">delete</mat-icon>
            {{ item }}
          </li>
        </ul>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Formulario -->
  <form [formGroup]="form" class="confirmation-form">

    <!-- Campo de razón (opcional) -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Motivo de eliminación (opcional)</mat-label>
      <textarea
        matInput
        formControlName="reason"
        placeholder="Describe brevemente el motivo de la eliminación..."
        rows="2"
        maxlength="200">
      </textarea>
      <mat-hint align="end" class="char-counter">
        {{ form.get('reason')?.value?.length || 0 }}/200
      </mat-hint>
    </mat-form-field>

    <!-- Campo de confirmación -->
    <div class="confirmation-section">
      <p class="confirmation-instruction">
        Para confirmar la eliminación, escriba <strong>"{{ confirmationText }}"</strong> en el siguiente campo:
      </p>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Escriba {{ confirmationText }} para confirmar</mat-label>
        <input
          matInput
          formControlName="confirmation"
          [placeholder]="confirmationText"
          autocomplete="off"
          class="confirmation-input">
        <mat-error *ngIf="confirmacionControl?.hasError('required')">
          Este campo es requerido
        </mat-error>
        <mat-error *ngIf="confirmacionControl?.hasError('confirmacionIncorrecta')">
          Debe escribir exactamente "{{ confirmationText }}"
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</div>

<mat-divider></mat-divider>

<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()" class="cancel-button">
    <mat-icon>close</mat-icon>
    Cancelar
  </button>
  <button
    mat-raised-button
    color="warn"
    (click)="onConfirm()"
    [disabled]="!isFormValid()"
    class="confirm-button delete-button">
    <mat-icon>delete_forever</mat-icon>
    Eliminar {{ data.entityName }}
  </button>
</div>
